module.exports = __webpack_public_path__ + "img/Tessellate51.9cbb18f6.jpg";